import React, { useEffect, useState } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import {
  FormikSwitch,
  FormikTextField,
} from '../../../common/formik-material-ui';
import { Formik } from 'formik';
import { FormControlLabel } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { user } from '../../../recoil/atoms/user';
import { useSnackbarWithStyles } from '../notifications/SnackbarProviderWithStyles';
import { ModalWithStyles } from './ModalWithStyles';
import Axios from 'axios';
import { useParams } from 'react-router-dom';
import { LabelledOutline } from 'src/common/final-form-material-ui';

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
    width: '339px',
  },
  modal: {
    paddingBottom: 0,
    maxHeight: 'calc(100vh - 210px)',
    overflowY: 'auto',
  },
}));
export function EditBlockedNumberModal({
  show,
  onHide,
  setRefetchToggleForBlockedNumbers,
  numbers,
}) {
  const userAtom = useRecoilValueLoadable(user);
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const classes = useStyles();
  const { id: idFromUrl } = useParams();
  const [rowData, setRowData] = useState({
    inboundcalls: false,
    outboundcalls: false,
    inboundsms: false,
    outboundsms: false,
  });
  // unique id is created by combining created date and number so we extract the number by splitting it by the comma
  const realId = idFromUrl.split(',');
  useEffect(() => {
    const found = numbers?.find((num) => num.number === realId[0]);
    setRowData(found);
  }, [idFromUrl, numbers, realId]);
  return (
    <Formik
      onSubmit={async (values, actions) => {
        const {
          number,
          inboundCalls,
          outboundCalls,
          inboundSMS,
          outboundSMS,
        } = values;
        const data = JSON.stringify({
          businessid: userAtom.contents?.businessid,
          apikey: userAtom.contents?.apikey,
          outboundsms: outboundSMS,
          number,
          inboundsms: inboundSMS,
          inboundcalls: inboundCalls,
          outboundcalls: outboundCalls,
          update: true,
        });
        const url = `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/blockedNumbers/numbers`;
        const response = await Axios.post(url, data);
        if (response.data.body.success) {
          enqueueSnackbarWithStyles({
            message: `Successfully Updated Blocked Number - ${number}`,
            alertProps: { severity: 'success' },
          });
          setRefetchToggleForBlockedNumbers({});
        }
        onHide();
        actions.resetForm({});
      }}
      //   validationSchema={}
      enableReinitialize={true}
      initialValues={{
        number: realId[0],
        inboundCalls: rowData?.inboundcalls ?? false,
        outboundCalls: rowData?.outboundcalls ?? false,
        inboundSMS: rowData?.inboundsms ?? false,
        outboundSMS: rowData?.outboundsms ?? false,
      }}
    >
      {(formik) => (
        <>
          <form
            // className="form form-label-right"
            onSubmit={formik.handleSubmit}
            className={classes.input}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Update Blocked Number"
              show={show}
              onHide={onHide}
              isSubmitting={formik.isSubmitting}
              disableSubmit={!formik.dirty}
              size="xs"
            >
              <div className="container">
                <div className="col">
                  <FormikTextField
                    id="standard-basic"
                    label="Number"
                    className={classes.field}
                    name="number"
                    formik={formik}
                    size="small"
                    variant="outlined"
                    required
                    disabled
                    helperText="e164"
                    fullWidth
                  />
                </div>
                <div style={{ marginLeft: '14.5px' }} className="row">
                  <LabelledOutline label="Calls" customPadding="5px 8px">
                    <FormControlLabel
                      control={
                        <FormikSwitch
                          name="inboundCalls"
                          formik={formik}
                          color="primary"
                          type="checkbox"
                        />
                      }
                      label="Inbound Calls"
                    />

                    <FormControlLabel
                      control={
                        <FormikSwitch
                          name="outboundCalls"
                          formik={formik}
                          color="primary"
                          type="checkbox"
                        />
                      }
                      label="Outbound Calls"
                    />
                  </LabelledOutline>
                </div>
                <div
                  style={{
                    marginLeft: '14.5px',
                    marginTop: '10px',
                  }}
                  className="row"
                >
                  <LabelledOutline label="SMS" customPadding="5px 8px">
                    <FormControlLabel
                      control={
                        <FormikSwitch
                          name="inboundSMS"
                          formik={formik}
                          color="primary"
                          type="checkbox"
                        />
                      }
                      label={'Inbound SMS' + '\xa0\xa0'}
                    />
                    <FormControlLabel
                      control={
                        <FormikSwitch
                          name="outboundSMS"
                          formik={formik}
                          color="primary"
                          type="checkbox"
                        />
                      }
                      label={'Outbound SMS' + '\xa0'}
                    />
                  </LabelledOutline>
                </div>
              </div>
              <br />
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
